import axios from "axios";
import { ParticipantDirectoryInterface, server } from "../../app/consts";

axios.defaults.withCredentials = true;

export const getDirectory = async () => {
    try {
        const res = await axios.get(server + "getDirectory")
        return res.data
    }
    catch (error: unknown) {
        return Promise.reject(error)
    }
}

export const updateDirectory = async (data:ParticipantDirectoryInterface) => {
    try {
        const res = await axios.patch(server + "updateDirectory",data)
        return res.data
    }
    catch (error: unknown) {
        return Promise.reject(error)
    }
}

